import EmailLink from "../../../../common/CommentList/common/EmailLink/EmailLink";
import PhoneLink from "../../../../common/CommentList/common/PhoneLink/PhoneLink";
import TitreZone from "../../../../common/CarteLead/TitreZone";
import useLeadAutoItem from "../useLeadAutoItem";

const euros = (n) => `${Math.round(n).toLocaleString("fr-FR")} €`;

// Contact et demande : téléphone, email, véhicule, prime estimée. Le titre
// ouvre « Infos et documents » dans le panneau.
const ZoneContact = ({ ouvrir }) => {
  const { leadAutoItem } = useLeadAutoItem();
  const user = leadAutoItem.user || {};
  const productData = leadAutoItem.productdata || {};
  const vehicule = [productData.marque_vehicule, productData.modele_vehicule, productData.version_vehicule]
    .filter(Boolean)
    .join(" ");
  const prime = productData.prime_annuelle_ttc;

  return (
    <section className="la-zone" aria-label="Contact et demande">
      <TitreZone icone="fa-id-card" onglet="infos" ouvrir={ouvrir}>
        Contact et demande
      </TitreZone>
      <ul className="la-coord">
        <li>
          <PhoneLink phone={user.telephone} />
        </li>
        <li>
          <EmailLink email={user.email} />
        </li>
      </ul>
      {vehicule && (
        <span className="la-vehicule" title={vehicule}>
          <i className="fa fa-car-side" aria-hidden="true" />
          <span>{vehicule}</span>
        </span>
      )}
      {prime > 0 && (
        <div className="la-prime">
          Prime estimée <b>{euros(prime)}</b> par an
        </div>
      )}
    </section>
  );
};

export default ZoneContact;
